export enum RubricType {
    DefinedPoints = 'DefinedPoints',
    NotDefinedPoints = 'NotDefinedPoints',
}

export enum RubricScoringType {
    Scoring = 'Scoring',
    NonScoring = 'NonScoring',
    NotSelected = '',
}

export enum RubricNonScoringType {
    New = 'New',
    FromExisting = 'FromExisting',
}
